// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { rtdbPlugin as VueFire } from 'vuefire'
import VueAnalytics from 'vue-analytics'

import App from './App'
import router from './router'
import Spinner from 'vue-simple-spinner'

Vue.config.productionTip = false
Vue.component('vue-simple-spinner', Spinner)
Vue.use(VueFire)

Vue.use(VueAnalytics, {
  id: 'UA-112745740-1',
  router
})
/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
